import styled, { css } from 'styled-components';

import { CollapseAnimationStyles, FlexParentBlock } from '../../../styled';

export const CheckListWrapper = styled.div`
  width: 235px;
`;

// Check list header styles;

const ProgressBarStyles = css`
  border-radius: 4px;
  height: 4px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
`;

export const TabletImage = styled.img`
  width: 65px;
`;

export const ProgressTitle = styled.p`
  ${(props) => props.theme.typography.description}
  margin-bottom: 4px;
`;

export const ProgressBarWrapper = styled.div`
  ${ProgressBarStyles};
  width: 100%;
  background-color: ${(props) => props.theme.colors.stroke};
`;

export const ProgressBar = styled.div<{ progress: number }>`
  ${ProgressBarStyles};
  background-color: ${(props) => props.theme.colors.action};
  width: ${(props) => props.progress}%;
`;

export const ProgressColumn = styled.div`
  width: 100%;
`;

export const UnionIcon = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 6px;
  background: linear-gradient(180deg, #2888f5 0%, #0073f7 100%);
  box-shadow: 0 1px 4px 0 #01285440;
`;

export const WarningSubtitle = styled.p`
  max-width: 230px;
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 24px;
  color: ${(props) => props.theme.colors.text};
`;

//  Check list item styles;

export const CustomStorageCardWrapper = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.stroke};
  margin-bottom: 16px;
`;

export const CheckListCardWrapper = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.stroke};
  margin-bottom: 16px;
  :last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
  :first-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`;

export const CheckListCardHead = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding-bottom: 16px;
`;

export const FlexWithGap = styled(FlexParentBlock)`
  gap: 16px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const ElementStyles = css`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  margin-right: 8px;
  box-sizing: border-box;
`;

export const CheckedElement = styled.h4`
  ${ElementStyles};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.action};
`;

export const UncheckedElement = styled.div`
  ${ElementStyles};
  opacity: 0.5;
  border: 2px solid ${(props) => props.theme.colors.brand};
`;

const DisabledStyles = css`
  cursor: auto;
  color: ${(props) => props.theme.colors.disabled};
  :hover {
    color: ${(props) => props.theme.colors.disabled};
  }
`;

export const ItemTitle = styled.h4<{ disabled: boolean }>`
  font-size: 11px;
  line-height: 16px;
  margin-right: 4px;
  cursor: pointer;
  :hover {
    color: ${(props) => props.theme.colors.brand};
  }
  ${(props) => props.disabled && DisabledStyles};
`;

export const DangerTitle = styled.p`
  font-size: 11px;
  line-height: 16px;
  color: ${(props) => props.theme.colors.danger};
  margin: 0;
  margin-right: 4px;
`;

export const CheckListCardContent = styled.div<{ contentHeight: number }>`
  ${(props) => CollapseAnimationStyles(props.contentHeight)};
`;

export const CheckListCardTitle = styled.h3`
  text-transform: uppercase;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1px;
  margin-bottom: 4px;
`;

export const CheckListCardSubtitle = styled.p`
  font-size: 13px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.disabled};
`;

export const ProgressCircleWrapper = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 16px;
  border-width: 2px;
  border-style: dashed;
  border-color: #bb9898;
  border-radius: 50%;
`;

export const ProgressCircle = styled.div``;

export const OpenSettingsDescription = styled.p`
  ${(props) => props.theme.typography.notification};
  margin-top: 7px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.muted};
`;

export const RestSettingsSubtitle = styled.p`
  ${(props) => props.theme.typography.caption};
  margin-bottom: 16px;
`;

export const ProgressIconWrapper = styled.div`
  margin-right: 8px;
`;

export const TitlesWrapper = styled.div`
  padding-top: 4px;
  margin-right: 18px;
`;

export const ChevronMiniWrapper = styled.div<{ isOpen: boolean }>`
  color: ${(props) => props.theme.colors.brand};
  width: 24px;
  svg {
    ${(props) => props.isOpen && 'transform: rotate(180deg);'}
    transition: 0.2s;
  }
`;
